import { jsx as _jsx } from "react/jsx-runtime";
import { DialogView } from 'widgets/settings-master/ui/dialog-view';
import { AgainConfigWarning } from 'widgets/settings-master/ui/again-config-warning';
import { SettingsMasterContextProvider } from 'widgets/settings-master/model/context';
import { RouterDialog } from 'shared/components/dialogs/router';
export const master_settings_routes = [
    {
        path: '/master-settings',
        element: (_jsx(SettingsMasterContextProvider, { children: _jsx(RouterDialog, { title: "\u041C\u0430\u0441\u0442\u0435\u0440 \u041D\u0430\u0441\u0442\u0440\u043E\u0435\u043A" }) })),
        children: [
            {
                path: 'warning',
                element: _jsx(AgainConfigWarning, {}),
            },
            {
                path: 'list/:boardId',
                element: _jsx(DialogView, {}),
            },
        ],
    },
];
